import * as React from 'react'

import { Text, TextName } from 'sdk/text/Text'

import type { AboutOurStoryCmsContent } from 'core/services/cms/interfaces'

import { Storyline } from './components/Storyline'

import classes from './style.module.scss'

interface OurStorySectionProps {
  content: AboutOurStoryCmsContent
}

export const OurStorySection: React.FC<OurStorySectionProps> = ({ content }) => {
  return (
    <div className={classes.container}>
      <Text type={TextName.H2} className={classes.title}>
        {content.title}
      </Text>
      <Storyline milestones={content.milestones} />
    </div>
  )
}
